// **********************************************************
// 1.0 - Gallery Modal Slider
// **********************************************************

const galleryModalSwiperElements = document.querySelectorAll('[data-slider="gallery-modal"]');
const galleryModalOptions = {
  slidesPerView: 1,
  spaceBetween: 30,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  navigation: {
    prevEl: '.swiper-button-next',
    nextEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
    renderFraction(currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span> — </span><span class="${totalClass}"></span><span></span>`;
    },
  },
};

galleryModalSwiperElements.forEach((el) => {
  const galleryModalParent = el.closest('.gallery-modal');
  const arrowRight = galleryModalParent.querySelector('.arrow-right');
  const arrowLeft = galleryModalParent.querySelector('.arrow-left');
  const paginationElement = galleryModalParent.querySelector('.swiper-pagination');

  galleryModalOptions.navigation.nextEl = arrowRight;
  galleryModalOptions.navigation.prevEl = arrowLeft;
  galleryModalOptions.pagination.el = paginationElement;

  // eslint-disable-next-line no-new
  const galleryModalSlider = new Swiper(el, galleryModalOptions);

  attachEvent('[data-modalslide]', 'click', (ev) => {
    const targetSlide = ev.target.getAttribute('data-modalslide');
    galleryModalSlider.slideTo(targetSlide - 1, 0);
  });
});

// **********************************************************
// 2.0 - Gallery Modal Close
// **********************************************************

attachEvent('.gallery-modal__close-btn', 'click', (ev) => {
  ev.target.closest('.gallery-modal').classList.remove('is-open-modal');
});

// **********************************************************
// 3.0 - Closing Modal on Esc
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.gallery-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
    });
  }
});
